import { useRef, useState } from 'react';

import { useEventCallback, useMeasure } from '@spazious/react-hooks';

/**
 * Returns the current scroll position and an onScroll handler.
 */
export const useScroll = () => {
  const elemRef = useRef<HTMLElement | null>(null);
  const [measureRef] = useMeasure();

  const [scrollTop, setScrollTop] = useState(0);

  const onScroll = <T = Element>(evt: React.UIEvent<T>) => {
    const elem = evt.target as HTMLElement;

    setScrollTop(elem.scrollTop);
  };

  const { scrollHeight = 0, clientHeight = 0 } = elemRef.current ?? {};

  const ref = useEventCallback((elem: HTMLElement | null) => {
    elemRef.current = elem;
    measureRef(elem as Element);
  });

  return [
    {
      scrollTop,
      top: scrollTop === 0,
      bottom: Math.abs(scrollHeight - scrollTop - clientHeight) < 1,
    },
    { onScroll, ref },
  ] as const;
};
